import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Link } from '@atoms/Link/Link';

const reportItCookieDefault = 'westminster-city-council_cookiecontrol-version';
const reportItCookieDefaultContent = '1.0.0';
const reportItCookie = 'westminster-city-council_cookiecontrol';
const reportItCookieContent = '2';

/**
 * Cookie component
 *
 * @category Cookies
 * @props
 */

type WestminsterCityCouncilCookie =
  | 'westminster-city-council_cookiecontrol-version'
  | 'westminster-city-council_cookiecontrol';

export const CookieBanner: React.FunctionComponent = () => {
  const [showCookieBanner, setshowCookieBanner] = useState<string>('');
  const [cookies, setCookie] = useCookies<WestminsterCityCouncilCookie>([
    'westminster-city-council_cookiecontrol-version',
  ]);

  const hideCookieBanner = () => {
    setCookie(reportItCookie, reportItCookieContent, { path: '/' });
    setCookie(reportItCookieDefault, reportItCookieDefaultContent, {
      path: '/',
    });
    setshowCookieBanner('');
  };
  const removeCookieClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setCookie(reportItCookieDefault, reportItCookieDefaultContent, {
      path: '/',
    });
    setshowCookieBanner('');
  };

  useEffect(() => {
    if (cookies[reportItCookieDefault] !== reportItCookieDefaultContent) {
      setshowCookieBanner('show');
    }
  }, [cookies, setCookie]);

  return (
    <div
      className={`bg-brand-primary border-accent-highlight fixed bottom-0 left-0 z-[999] m-0 w-full transform rounded-none border-t-[0.4rem] border-solid text-white opacity-100 transition-transform duration-200 ease-out ${showCookieBanner === 'show' ? 'translate-y-0' : 'translate-y-full'}`}
      role="alert"
    >
      <div className="flex flex-col p-6 lg:flex-row">
        <div className="flex flex-1 flex-col text-left">
          <div>
            <p className="header-4 mb-[1.6rem] p-0 text-white">
              We use cookies on this site to enhance your user experience
            </p>
            <p className="text-body mb-[0.625rem] p-0">
              By clicking the Accept button, you agree to us doing so.
            </p>
            <div>
              <Link
                href="https://www.westminster.gov.uk/data-protection/privacy"
                external={true}
                linkType="popup"
              >
                More info on our cookie policy
              </Link>
            </div>
          </div>
        </div>
        <div className="ml-auto flex w-full flex-col text-right lg:w-auto">
          <div className="flex w-full justify-between pt-[2.5rem] lg:w-auto lg:flex-col lg:pt-0">
            <button
              type="button"
              className="hover:bg-action-focus focus:bg-action-focus active:bg-action-focus active:border-action-focus
              text-action-button active:text-text-body hover:text-text-body inline-block rounded-[0.4rem] bg-white
              px-[1.2rem] py-[0.8rem] text-center text-lg leading-[1.336rem]
              outline-none hover:outline-none active:border-[0.2rem] active:border-solid"
              onClick={hideCookieBanner}
            >
              Accept cookies policy
            </button>
            <div className="mt-3 underline lg:mx-auto">
              <Link
                href=""
                external={false}
                onClick={removeCookieClick}
                linkType="popup"
              >
                No, thanks
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
